import axios from '@/lib/axios';
import { FixedAsset, Product, PurchaseOrderComment, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0631. 発注案件コメントリアクションtoggle
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  emoji_id: string;
  content: string;
};
const purchaseOrderCommentReaction = (props: Props): Promise<PurchaseOrderComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_comments/${props.id}/reactions`,
    props
  );
};

export const usePurchaseOrderCommentReaction = () => {
  return useMutation({
    mutationFn: purchaseOrderCommentReaction,
  });
};
